export default "__VITE_ASSET__BsczGNkM__"